import { Autocomplete, Chip, TextField } from "@mui/material";
import { ErrorMessage } from "formik";

type prop = {
  option: any;
  label: string;
  required?: boolean;
  value: any;
  onChange: (value: any) => void;
  name?: string;
  placeholder?: string;
  multiple?:boolean ;
  labelClasses?:string ;
  variant?:'filled' | 'outlined' | 'standard'
};

const ATMTagAutoComplete = ({
  option,
  label,
  required = false,
  value,
  onChange,
  multiple=false ,
  variant ='outlined',
  name,
  labelClasses,
  placeholder = "Enter Name",
}: prop) => {
  return (
    <div className="relative">
      {label && (
        <label className={`${labelClasses} font-medium text-slate-700`}>
          {" "}
          {label} {required && <span className="text-red-500"> * </span>}{" "}
        </label>
      )}
      <Autocomplete
        className="mt-1 outline-none !border-r-0 !border-0 "
        multiple={multiple}
        value={value}
        id="tags-filled"
        onChange={(e: any, value: any) => {
          onChange(value);
        }}
        options={option?.map((option: any) => option?.title)}
        freeSolo
        renderTags={(value: readonly string[], getTagProps) =>
          value?.map((option: string, index: number) => (
            <Chip
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder} 
             variant={variant}
            size="small"
            fullWidth
            className="bg-white !outline-none "
          />
        )}
      />
      {name && (
        <ErrorMessage name={name}>
          {(errMsg) => (
            <p className="font-poppins absolute text-[14px] text-start mt-0 text-red-500">
              {errMsg}
            </p>
          )}
        </ErrorMessage>
      )}
    </div>
  );
};

export default ATMTagAutoComplete;
